import { Content } from '@visikon/core-models';
import { APIUtils } from 'commons/utils';
import axios from 'axios';
import { useQuery } from 'react-query';
import { useRecoilState } from 'recoil';
import { tokenState } from 'redux-recoil-sync.state';
import { QueryConfig } from '../react-query-utils';
import { URLS } from '../urls';
import { CompositionUsageResponse } from 'api/compositionApi';

export const VIDEOS_CACHE_KEY = 'videos';


export function useVideoUsage(id: string) {
  const [token] = useRecoilState(tokenState);

  return useQuery<CompositionUsageResponse>(
    [VIDEOS_CACHE_KEY, 'usage', id],
    async () => {
      const result = await axios.get<CompositionUsageResponse>(URLS.videos.usage(id), APIUtils.tokenHeader(token!));

      return result.data;
    },
    { ...QueryConfig, enabled: !!token && id !== 'new', retry: false },
  );
}
